import { IUpdateRulesPoliciesPayload } from '../../Services/api/price-policies/price-policies.interface'
import { PricePoliciesApiRemoteService } from '../../Services/api/price-policies/price-policies-service'
import { IUpdateProductPayload } from '../../Services/api/products/products.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class UpdatePricePoliciesRulesUseCase
implements IFormUsecase<IUpdateRulesPoliciesPayload, void> {
  constructor (private readonly PricePoliciesApi: PricePoliciesApiRemoteService) {}
    

  public async handle (
    data: IUpdateRulesPoliciesPayload
  ): Promise<Result<void>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.PricePoliciesApi.updateRule(data)

      if (response.isFailure) {
        return response
      }

    
      return Result.ok()
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
